import { getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import factoryAuthService from '../modules/requests/services'

/**
 * Gets the sector KPIs by the given year.
 */
export const getSector = factoryAuthService(({ sectorId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sector/getKPI/${year}/${sectorId}`)
)

/**
 * Gets the buyers by the given identifier, mechanism, and year.
 */
export const getSectorBuyers = factoryAuthService(({ mechanismId, order, sectorId, year }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sector/organism/${year}/${sectorId}/${mechanismId}/${order}`)
})

/**
 * Gets the categories by the given identifiers and year.
 */
export const getSectorCategories = factoryAuthService(({ familyId, sectorId, segmentId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/treeMapSector/getByFamily/${year}/${sectorId}/${segmentId}/${familyId}`)
)

/**
 * Gets the families by the given identifiers and year.
 */
export const getSectorFamilies = factoryAuthService(({ sectorId, segmentId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/treeMapSector/getBySegment/${year}/${sectorId}/${segmentId}`)
)

/**
 * Gets the providers by the given identifier, mechanism, and year.
 */
export const getSectorProviders = factoryAuthService(({ direction, mechanismId, order, page, sectorId, year }) => {
  const query = new window.URLSearchParams({
    direction,
    order,
    page,
    year,
    idModalidad: mechanismId,
    idSector: sectorId,
    size: 10
  })

  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sector/find/list?${query.toString()}`)
})

/**
 * Gets the purchasing mechanisms of the given sector of the given year.
 */
export const getSectorPurchasingMechanisms = factoryAuthService(({ proccessId, sectorId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/supplierstate/list/${proccessId}/${year}/${sectorId}`)
)

/**
 * Gets the products by the given identifiers and year.
 */
export const getSectorProducts = factoryAuthService(({ categoryId, familyId, sectorId, segmentId, year }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/treeMapSector/getByCategory/${year}/${sectorId}/${segmentId}/${familyId}/${categoryId}`
  )
)

/**
 * Gets the segments by the given identifier and year.
 */
export const getSectorSegments = factoryAuthService(({ sectorId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/treeMapSector/getSectors/${year}/${sectorId}`)
)

/**
 * Gets the biddings by the given identifier and year.
 */
export const getSectorBiddings = factoryAuthService(({ sectorId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sankeySector/all/${year}/${sectorId}`)
)

/**
 * Gets the biddings KPIs by the given sector and year.
 */
export const getSectorBiddingKPIs = factoryAuthService(({ sectorId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sankeySector/kpi/${year}/${sectorId}`)
)

/**
 * Gets the sector filters by the search rubro */
export const getSectorFilter = factoryAuthService(({ term }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/elastic/rubroproducto/searchByFilter/1/${term}`)
)
